import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout, BookOpen, Megaphone, BarChart3, DollarSign, Briefcase, ChevronRight } from 'lucide-react';

const PracticeTools = () => {
  const navigate = useNavigate();

  const tools = [
    {
      id: 'services-events',
      icon: Briefcase,
      title: 'Events',
      description: 'Workshops, retreats, and group sessions',
      path: '/dashboard/services',
      color: 'rose',
    },
    {
      id: 'site-editor',
      icon: Layout,
      title: 'Site Editor',
      description: 'Customize and publish your site',
      path: '/site-editor',
      color: 'purple',
      tourId: 'site-editor'
    },
    {
      id: 'business-playbook',
      icon: BookOpen,
      title: 'Business Playbook',
      description: 'Guides and resources to grow',
      path: '/business-playbook',
      color: 'indigo',
      tourId: 'business-playbook'
    },
    {
      id: 'analytics',
      icon: BarChart3,
      title: 'Analytics',
      description: 'Track site visits and patterns',
      path: '/dashboard/analytics',
      color: 'green',
    },
    {
      id: 'earnings',
      icon: DollarSign,
      title: 'Earnings',
      description: 'Revenue, payouts, and financials',
      path: '/dashboard/earnings',
      color: 'amber'
    },
    {
      id: 'marketing',
      icon: Megaphone,
      title: 'Marketing',
      description: 'Campaigns, ads, and growth tools',
      path: '/dashboard/marketing',
      color: 'blue',
    }
  ];

  const colorClasses = {
    rose: 'bg-rose-100 text-rose-600',
    purple: 'bg-purple-100 text-purple-600',
    indigo: 'bg-indigo-100 text-indigo-600',
    blue: 'bg-blue-100 text-blue-600',
    green: 'bg-green-100 text-green-600',
    amber: 'bg-amber-100 text-amber-600'
  };

  return (
    <div className="mb-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Practice Tools</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {tools.map((tool) => {
          const Icon = tool.icon;
          const isDisabled = tool.comingSoon;

          return (
            <button
              key={tool.id}
              onClick={() => !isDisabled && navigate(tool.path)}
              disabled={isDisabled}
              data-tour={tool.tourId}
              className={`group text-left p-6 bg-white rounded-lg border border-gray-200 transition-all ${
                isDisabled
                  ? 'opacity-60 cursor-not-allowed'
                  : 'hover:border-purple-300 hover:shadow-md cursor-pointer'
              }`}
            >
              <div className="flex items-start justify-between mb-3">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${colorClasses[tool.color]}`}>
                  <Icon className="w-6 h-6" />
                </div>
                {!isDisabled && (
                  <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-purple-600 transition-colors" />
                )}
                {isDisabled && (
                  <span style={{ backgroundColor: '#ecfeff', color: '#0e7490', padding: '2px 8px', borderRadius: '12px', fontSize: '10px', fontWeight: 600 }}>
                    Soon
                  </span>
                )}
              </div>

              <h3 className="font-semibold text-gray-900 mb-1 text-sm">
                {tool.title}
              </h3>
              <p className="text-xs text-gray-600 leading-relaxed">
                {tool.description}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default PracticeTools;
